import React from 'react'
import { General } from './General'
import { Library } from './Library'
import { LibraryForm } from './LibraryForm'
import { Approver } from './Approver'
import { Report } from './Report'
import { Inquiries } from './Inquiries'

export const Walkthrough = () => {
    return (
        <React.Fragment>
            <General/>
            <Library/>
            <LibraryForm/>
            <Approver/>
            <Report/>
            <Inquiries/>     
        </React.Fragment>
    )
}
